// Meta Pixel utility
const PIXEL_ID = '1445490070556037'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any
    _fbq: unknown
  }
}

export function initPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  // Build fbq stub
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue.push(args)
    }
  }
  fbq.callMethod = null as unknown
  fbq.queue = [] as unknown[][]
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  // Inject fbevents.js
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Airbnb Superhost Spanish OS',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
